import { getRecordingReportAction } from './actionTypes';

export function getRecordingReport(webinarLocale, recordingKey = '', format = '', timeZone) {
  return {
    type: getRecordingReportAction.toString(), recordingKey, format, webinarLocale, timeZone
  };
}
